import React from "react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function init() {
  return <ToastContainer />;
}

export default {
  init,
  success: toast.success,
  error: toast.error,
  failure: toast.failure,
  notification: toast.notification,
  info: toast.info,
};
